import { cardStyles, Typography } from '@maia/ui';
import { Link, LinkOptions, ReactNode } from '@tanstack/react-router';

export interface BaseCardProps {
  readonly to?: LinkOptions;
  readonly children?: ReactNode;
}

export function CardBase(props: BaseCardProps) {
  const { to, children } = props;

  return (
    <div
      className={cardStyles({
        variant: 'elevated',
        className: 'flex items-center py-20 px-24 gap-x-48',
      })}
    >
      {children}
      {to && (
        <Link {...to}>
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-primaryMain"
          >
            Koppelen
          </Typography>
        </Link>
      )}
    </div>
  );
}
